<script>
  import { onMount, createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher();

  export let REC_TIME
  export let timeLeft

  const WIDTH = 148
  const HEIGHT = 64
  const RADIUS = 27
  const FULL_DASH_ARRAY =
    2 * (WIDTH + HEIGHT - 4 * RADIUS) + 2 * Math.PI * RADIUS // 角丸長方形の周長

  let rect

  onMount(() => {
    rect.setAttribute("stroke-dasharray", FULL_DASH_ARRAY)
    rect.setAttribute("stroke-dashoffset", FULL_DASH_ARRAY)
  })

  function setCircleDashoffset(elapsedTime) {
    const dashoffset = FULL_DASH_ARRAY * (1 - elapsedTime / REC_TIME)
    if (rect) rect.setAttribute("stroke-dashoffset", dashoffset)
  }

  $: (() => setCircleDashoffset(REC_TIME - timeLeft))()
</script>

<button
  type="button"
  on:click={() => dispatch('click')}
  class="relative w-[148px] h-16 rounded-[60px] flex items-center justify-center"
>
  <svg
    class="absolute top-0 left-0 z-10"
    view-box="0 0 148 64"
    width="148"
    height="64"
  >
    <rect
      bind:this={rect}
      class="progress-ring__rect"
      stroke="#F47B7B"
      stroke-width="2"
      fill="transparent"
      x="1"
      y="1"
      width="146"
      height="62"
      rx="27"
    />
  </svg>
  <div class="absolute top-0 left-0 w-[148px] h-16 rounded-[29px]  bg-white z-0 flex items-center justify-center">
    <div class="w-[144px] h-[60px] rounded-[26px] bg-white border-2 border-black flex items-center justify-center">
      <div class="flex items-center justify-between w-[84px] h-5">
        <div class="w-4 h-4 rounded bg-site-red-2"></div>
        <span class="text-site-red-2 text-sm font-bold"><slot></slot></span>
      </div>
    </div>
  </div>
</button>

<style>
.progress-ring__rect {
  transition: 0.1s stroke-dashoffset linear;
}
</style>
